import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router'
import {useRegisterStore} from "@domains/auth/stores/register.store";
import {AuthenticationNs, DashboardNs, type SignUpNs} from "@shared/types";

export const confirmInvitationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {
    if (to.query.ex === 'true') {
        const payload = {
            activationCode: to.query.ac,
            invId: to.query.inv
        } as SignUpNs.ActivateAccountRequest

        const registerStore = useRegisterStore();
        registerStore.confirmInvitation(payload).then(() => {
            next({name: AuthenticationNs.AuthenticationRouteEnums.ExistingWorkspaces})
        }).catch(() => {
            next({name: AuthenticationNs.AuthenticationRouteEnums.SignIn})
        })
    } else {
        next({name: 'LetsStart', query: to.query})
    }
}
